import { useQuery } from '@tanstack/react-query';
import type { IntelSummary } from 'design-system';
import { MorningIntelFeed } from 'design-system';
import { useSearchParams } from 'react-router';

import useDocumentTitleRename from '@/shared/hooks/useDocumentTitleRename';

import { marketEventsOptions } from '../api/marketEvents.options';
import { SIGNAL_QUERY_PARAM } from '../hooks/useSelectedSignal';
import { mockStatusLine } from '../lib/mockSignals';

const MorningIntelPage = () => {
  useDocumentTitleRename('GX Go | Morning Intel');
  const { data: signals = [] } = useQuery(marketEventsOptions.list());
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedSignalId = searchParams.get(SIGNAL_QUERY_PARAM) ?? undefined;

  // Clicking the already-selected signal deselects it, closing its Ask-GX context.
  const handleSignalSelect = (signal: IntelSummary) => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        if (next.get(SIGNAL_QUERY_PARAM) === signal.id) {
          next.delete(SIGNAL_QUERY_PARAM);
        } else {
          next.set(SIGNAL_QUERY_PARAM, signal.id);
        }
        return next;
      },
      { replace: true }
    );
  };

  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      <MorningIntelFeed
        signals={signals}
        statusLine={mockStatusLine}
        selectedSignalId={selectedSignalId}
        onSignalSelect={handleSignalSelect}
      />
    </div>
  );
};

export default MorningIntelPage;
